<!-- 伪评价页面 -->
<template>
  <div class="review-page">
    <title-bar-back :title="'全部评价'" @back="back"></title-bar-back>

    <div class="none_list">
      <img src="@/assets/order/search_none_product@2x.png" alt="" />
      <div class="font14 font_weight400 colo038 line_height_20">
        暂无评价
      </div>
    </div>
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);

export default {
  name: "BuyerReviews",
  components: {
    TitleBarBack
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    back() {
      this.$router.back();
    }
  }
};
</script>

<style lang="less" scoped>
.review-page {
  min-height: 100vh;
  background: #f7f8fa;
}

.none_list {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  img {
    width: 60px;
  }
}
</style>
